import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { LogService } from './log.service';


@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  url = "https://niivsnes.humge.com";
  ip:string;
  ip_id:number;
  constructor(private http: HttpClient,private logService:LogService) { 
  }

  saveSettings(data): Observable<any>{
    this.logService.log("Запазване на настройки ").subscribe();
    return this.http.post(this.url+'/api/settings?token='+localStorage.getItem('token'),data);
  }

  updateSettings(id,data): Observable<any>{
    this.logService.log("Промяна на настройки ").subscribe();
    return this.http.put(this.url+'/api/settings/'+id+'?token='+localStorage.getItem('token'),data);
  }

  getSettings(): Observable<any>{
    return this.http.get(this.url+'/api/settings?token='+localStorage.getItem('token'));
  }

  checkIp(): Observable<any> {
    return this.http.get(this.url+'/api/checkIp?token='+localStorage.getItem('token'));
  }

  getIps(): Observable<any> {
    return this.http.get(this.url+'/api/getIps?token='+localStorage.getItem('token'));
  }

  saveIp(data): Observable<any> {
    this.logService.log("Добавяне на ip за достъп ").subscribe();
    return this.http.post(this.url+'/api/saveIp?token='+localStorage.getItem('token'),data);
  }

  editIp(id): Observable<any> {
    return this.http.get(this.url+'/api/editIp/'+id+'?token='+localStorage.getItem('token'));
  }

  deleteIp(id): Observable<any> {
    this.logService.log("Изтриване на ip за достъп ").subscribe();
    return this.http.delete(this.url+'/api/deleteIp/'+id+'?token='+localStorage.getItem('token'));
  }

  updateIp(data,id): Observable<any> {
    this.logService.log("Промяна на ip за достъп ").subscribe();
    return this.http.put(this.url+'/api/updateIp/'+id+'?token='+localStorage.getItem('token'),data);
  }

  setip(ip){
    this.ip = ip;
  }

  getip(){
    return this.ip;
  }

  setIpId(id){
    this.ip_id = id;
  }

  getIpId(){
    return this.ip_id;
  }
}
